import { createAction, handleActions } from 'redux-actions'
import produce from 'immer'

const INIT_PRODUCT_DETAIL_INFO = 'productDetailInfoAction/initProductDetailState'
const UPDATE_PRODUCT_DETAIL_INFO = 'productDetailInfoAction/updateProductDetailState'

export const initProductDetailState = createAction(INIT_PRODUCT_DETAIL_INFO)
export const updateProductDetailState = createAction(UPDATE_PRODUCT_DETAIL_INFO)

const initialState = {
  productInfo: null,
  shippingInfo: null,
  productPolicyInfo: null,
  vendorInfo: null,
  reviewUrlInfo: null,
}

export default handleActions(
  {
    [INIT_PRODUCT_DETAIL_INFO]: (state, _) => {
      return produce(state, (draft) => {
        draft.productInfo = null
        draft.shippingInfo = null
        draft.productPolicyInfo = null
        draft.vendorInfo = null
        draft.reviewUrlInfo = null
      })
    },
    [UPDATE_PRODUCT_DETAIL_INFO]: (state, action) => {
      return produce(state, (draft) => {
        draft.productInfo = !action.payload.productInfo
          ? draft.productInfo
          : action.payload.productInfo
        draft.shippingInfo = !action.payload.shippingInfo
          ? draft.shippingInfo
          : action.payload.shippingInfo
        draft.productPolicyInfo = !action.payload.productPolicyInfo
          ? draft.productPolicyInfo
          : action.payload.productPolicyInfo
        draft.vendorInfo = !action.payload.vendorInfo ? draft.vendorInfo : action.payload.vendorInfo
        draft.reviewUrlInfo = !action.payload.reviewUrlInfo
          ? draft.reviewUrlInfo
          : action.payload.reviewUrlInfo
      })
    },
  },
  initialState,
)
